/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMailPause = createReactComponent("mail-pause", "IconMailPause", [
  [
    "path",
    {
      d: "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6",
      key: "svg-0"
    }
  ],
  ["path", { d: "M3 7l9 6l9 -6", key: "svg-1" }],
  ["path", { d: "M17 17v5", key: "svg-2" }],
  ["path", { d: "M21 17v5", key: "svg-3" }]
]);

export { IconMailPause as default };
//# sourceMappingURL=IconMailPause.js.map
